import type { EventRowLines } from "web_myplann/Shared/Types/EventRowLines";
import { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";
import { joinTruthy } from "web_myplann/Shared/Utils/textFormatters";
import { DOT_SEPARATOR } from "web_myplann/Utils/constants";

type ActivityRowInput = {
	typeLabel: string;
	dateLabel: string;
	title?: string | null;
	place?: string | null;
	person?: string;
};

export const mapActivityRowLines = ({
	typeLabel,
	dateLabel,
	title,
	place,
	person,
}: ActivityRowInput): EventRowLines => ({
	overline: joinTruthy([typeLabel, dateLabel], DOT_SEPARATOR),
	title: title ?? undefined,
	variant: EventRowVariant.List,
	details: [place, person].filter((detail): detail is string => !!detail),
});
